import { HardTokenIntegrationController } from '../hard-token-integration.controller';

export class Controller extends HardTokenIntegrationController {

    /** @ngInject */
    constructor(HardTokenService) {
        super(HardTokenService);
    }

    $onInit() {
        super.$onInit();
        this.type = 'THIRD_PARTY';
        this.otpType = 'TOTP';
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-integration/integrate-hard-token/integrate-hard-token.controller.js